export default class SelectorFilter {

	public static excludeByClass(nodeList: NodeList, exclusionClass: string) {

		let nodes: HTMLElement[] = [];

		for (let i = 0; i < nodeList.length; i++) {
			const node = nodeList[i] as HTMLElement;
			if (node !== undefined && !node.classList.contains(exclusionClass)) {
				nodes.push(node as HTMLElement);
			}
		}

		return nodes;

	}

	public static isValidIdSelector(id: string) {
		const idRegex = /^#[a-z]+[\w-]*$/i;
		return idRegex.test(id);
	}

}
